const itemsPerPage = [50, 100, 250];

// eslint-disable-next-line import/prefer-default-export
export { itemsPerPage };
